import Dialog from 'components/overlays/Dialog';
import type React from 'react';

import './_styles.scss';

interface Props {
    id: string;
    title?: string;
    form: React.JSX.Element;
    show: boolean;
    onCancel: () => void;
}

const FormDialog = ({ id, title, show, form, onCancel }: Props) => (
    <Dialog
        data-testid={`system-admin-dialog-form-${id}`}
        show={show}
        title={<p>{title}</p>}
        size='lg'
        body={form}
        onClose={onCancel}
        showCloseButton
    />
);

export default FormDialog;
